import React, { ChangeEvent } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import errorIcon from '@assets/img/error_alert_img.png';
import { INotification } from '@dataTypes/notificationTypes';
import NoticeContent from '@components/notification/NoticeContent';

interface NotificationModalProps {
  notificationData: INotification | null | undefined;
  show: boolean;
  onHide: () => void;
  hideDay?: boolean;
  onToggleHideDay?: (e: ChangeEvent<HTMLInputElement>) => void;
}

function NotificationModal({
  notificationData,
  show,
  onHide,
  hideDay,
  onToggleHideDay,
}: NotificationModalProps) {
  return (
    <Modal show={show} onHide={onHide} centered id="notification_modal_container">
      <Modal.Body>
        <div className="icon_bg">
          <img className="error_icon" src={errorIcon} alt="에러 아이콘" />
        </div>
        <p className="title">{notificationData?.title || '공지사항'}</p>
        {notificationData?.imageUrl ? (
          <div className="mb-3 text-center notification-banner-wrap">
            {notificationData.linkUrl ? (
              <a href={notificationData.linkUrl} target="_blank" rel="noopener noreferrer">
                <img
                  src={notificationData.imageUrl}
                  alt=""
                  className="notification-banner-img"
                  referrerPolicy="no-referrer"
                />
              </a>
            ) : (
              <img
                src={notificationData.imageUrl}
                alt=""
                className="notification-banner-img"
                referrerPolicy="no-referrer"
              />
            )}
          </div>
        ) : null}
        <div className="text">
          <NoticeContent content={notificationData?.content} />
        </div>
      </Modal.Body>
      <Modal.Footer>
        {/* 공지사항 관리 미리보기를 위한 버튼 비활성화 */}
        {hideDay !== undefined ? (
          <Form.Check
            type="checkbox"
            id={`hide_one_day_checkbox`}
            label={`일주일 동안 보지 않기`}
            onChange={onToggleHideDay}
            checked={hideDay}
          />
        ) : (
          <Form.Check
            type="checkbox"
            id={`hide_one_day_checkbox`}
            label={`일주일 동안 보지 않기`}
            disabled={true}
            checked={false}
          />
        )}

        <Button className="close_btn" onClick={onHide}>
          확인
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default NotificationModal;
